<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <tabs v-model="activeTab" @input="changeTab" class="empty-tab">
        <tab
          :key="`tab-${index}`"
          v-for="(tab, index) of authorizedTabs"
          :header="tab.label"
        >
        </tab>
      </tabs>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },

  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Statistique commerciaux",
          name: "statistique-commercials",
          requiredPermission: "STATS_STATS_COMMERCIALS_READ",
        },
        {
          label: "Acquisition/Fidélisation",
          name: "acquisition",
          requiredPermission: "STATS_ACQUISITION_READ",
        },
        {
          label: "Paiements encaissés",
          name: "cashed-payments",
          requiredPermission: "STATS_PAYMENTS_READ",
        },
        {
          label: "Attribution",
          name: "attributions-stats",
          requiredPermission: "STATS_ATTRIBUTION_READ",
        },
        {
          label: "Taux de marge",
          name: "margin-rate",
          requiredPermission: "STATS_MARGIN_RATE_READ",
        },
        {
          label: "B2C2B",
          name: "b2c2b",
          requiredPermission: "STATS_B2C2B_READ",
        },
      ],
    };
  },

  computed: {
    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return this.hasPermission(
          this.$store.state.user,
          tab.requiredPermission,
        );
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      this.$router.push({ name: this.authorizedTabs[index].name });
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) => tab.name === currentPath,
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }

  .tab-content {
    display: none;
  }
}
</style>
